import { useCallback } from "react";

const useValidation = () => {
	const validateName = useCallback((name) => {
		if (name || name.length === 0) {
			if (name.length < 2) {
				return "keyword.nameLengthError";
			}
		}
		return "";
	}, []);

	const validateEmail = useCallback((email) => {
		if (email) {
			if (!email.match(/^[æøåÆØÅa-zA-Z0-9_.-]+@[æøåÆØÅa-zA-Z0-9_.-]+\.\w+$/)) {
				return "keyword.emailFormatError";
			}
		}
		return "";
	}, []);

	const validatePhone = useCallback((phone) => {
		if (phone) {
			if (!phone.match(/^(\+\d{2})?\d{8}$/)) {
				return "keyword.phoneFormatError";
			}
		}
		return "";
	}, []);

	const validateIsNumbersOnly = useCallback((number) => {
		if (number) {
			if (!number.match(/^\d+$/)) {
				return "keyword.numberFormatError";
			}
		}
		return "";
	}, []);

	const validateZip = useCallback((zip) => {
		if (zip) {
			if (!zip.match(/^[0-9]{4}$/)) {
				return "keyword.zipFormatError";
			}
		}
		return "";
	}, []);

	const validateDate = useCallback((date) => {
		if (date) {
			if (!date.match(/^\d{4}-\d{2}-\d{2}$/)) {
				return "keyword.dateFormatError";
			}
		}
		return "";
	}, []);

	const validateFilename = useCallback((filename) => {
		if (filename.length < 1) {
			return "keyword.filenameLengthError";
		}
		return "";
	}, []);

	return {
		validateName,
		validateEmail,
		validatePhone,
		validateIsNumbersOnly,
		validateZip,
		validateDate,
		validateFilename,
	};
};

export default useValidation;
